import React from 'react'
import { Container, Col, Card } from 'react-bootstrap'

export default function MovementIndex() {

    return (
        <Col sm={3} >
            <Card border='dark'>
                <Container>
                    <h2>Two Cents</h2>
                    <br></br>
                    <a href='/TwoCents/Death'>Death With Dignity</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Covid19'>Life in the Age of COVID19</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Marines'>The Marines</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Prostitution'>Prostitution's Covergirl</a>
                    <br></br><br></br>
                    <a href='/TwoCents/GayWedding'>A Gay Wedding</a>
                    <br></br><br></br>
                    <a href='/TwoCents/BathroomLaws'>Bathroom Laws</a>
                    <br></br><br></br>
                    <a href='/TwoCents/WindowsVsMac'>Windows vs Mac</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Energy'>Is Energy Real?</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Romney'>Mitt Romney's Profile in Courage</a>
                    <br></br><br></br>
                    <a href='/TwoCents/HealthTips'>Health Tips</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Prius'>My Prius</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Wisdom'>Widsom: Hax, Pitts, Strayed & Sivers</a>
                    <br></br><br></br>
                    <a href='/TwoCents/Smoking'>Smoking</a>
                    <br></br><br></br>
                </Container>
            </Card>
        </Col >
    )
}